import { observer } from 'mobx-react';
import * as React from 'react';
import { GridColumn } from 'telia-front-react';
import { ContentType } from '../stores/movierental/MovieRentalCatalogStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface MovieResolutionsProps {
  price?: string;
  resolutions?: string[];
  isFreeOfCharge?: boolean;
  type?: string;
  packetIds?: number[];
  specialPricePacketIds?: number[];
}

const getSpecialPricePacketId = (packetIds: number[], specialPricePacketIds: number[]) => packetIds.find((id) => specialPricePacketIds.includes(id));

function MovieResolutionsAndPrice(props: MovieResolutionsProps): JSX.Element {
  const translate = React.useContext(TranslationsContext).translate;
  const { resolutions, price, type, isFreeOfCharge, packetIds, specialPricePacketIds } = props;

  const noPrice = !price || isFreeOfCharge;
  const specialPricePacketId = isFreeOfCharge || !specialPricePacketIds ? null : getSpecialPricePacketId(packetIds, specialPricePacketIds);

  const filterAndFormatResolutions = (): string[] => {
    return resolutions.filter((resolution) => resolution !== 'hls').map((resolution) => resolution.toUpperCase());
  };

  const renderPrice = (): JSX.Element => {
    if (specialPricePacketId) {
      return <> {translate(`movieRental.specialPrice.${specialPricePacketId}`)}</>;
    }
    if (noPrice) {
      return <> {translate('movieRental.priceFree')}</>;
    }
    return (
      <>
        <span>
          <>
            {price} {translate('movieRental.priceCurrency')}
          </>
        </span>
      </>
    );
  };

  const renderResolutionsAndPrice = (): JSX.Element => {
    return (
      <GridColumn width={['xs']}>
        {`${filterAndFormatResolutions().join(' / ')}:`}
        <strong>{renderPrice()}</strong>
      </GridColumn>
    );
  };

  const renderResolutionsWithPrices = (): JSX.Element => {
    return (
      <GridColumn width={['xs']}>
        {filterAndFormatResolutions().map((resolution, index, array) =>
          array.length - 1 === index ? (
            <span key={index}>
              {resolution}: <strong>{renderPrice()}</strong>
            </span>
          ) : (
            <span key={index}>
              {resolution}: <strong>{renderPrice()}</strong>
              {' / '}
            </span>
          ),
        )}
      </GridColumn>
    );
  };

  if (!resolutions || (resolutions.length === 1 && resolutions.includes('hls'))) {
    return (
      <GridColumn width={['xs']}>
        <strong>{renderPrice()}</strong>
      </GridColumn>
    );
  }

  if (noPrice || type === ContentType.SERIES || !!specialPricePacketId) {
    return <>{renderResolutionsAndPrice()}</>;
  }

  return <>{renderResolutionsWithPrices()}</>;
}

export default observer(MovieResolutionsAndPrice);
